(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gate-guru-product"] && !Shopify.designMode) return;
  try {
    
function initGuruPage(root){
 if(root.dataset.guruInitialized)return;
 root.dataset.guruInitialized='true';
 const tabs=[...root.querySelectorAll('[data-guru-tab]')],panels=[...root.querySelectorAll('[data-guru-panel]')];
 function selectTab(tab,focus){tabs.forEach(t=>{const on=t===tab;t.setAttribute('aria-selected',String(on));t.tabIndex=on?0:-1});panels.forEach(p=>{p.hidden=p.dataset.guruPanel!==tab.dataset.guruTab});if(focus)tab.focus()}
 tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>selectTab(tab,false));tab.addEventListener('keydown',e=>{let n=index;if(e.key==='ArrowDown'||e.key==='ArrowRight')n=(index+1)%tabs.length;else if(e.key==='ArrowUp'||e.key==='ArrowLeft')n=(index-1+tabs.length)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();selectTab(tabs[n],true)})});
 if(tabs.length)selectTab(tabs.find(t=>t.getAttribute('aria-selected')==='true')||tabs[0],false);
 root.classList.add('guru-ready');
 const gallery=root.querySelector('.guru-gallery'),prev=root.querySelector('[data-guru-gallery-prev]'),next=root.querySelector('[data-guru-gallery-next]');
 if(gallery&&prev&&next){function state(){prev.disabled=gallery.scrollLeft<=2;next.disabled=gallery.scrollLeft+gallery.clientWidth>=gallery.scrollWidth-2}function move(direction){gallery.scrollBy({left:direction*Math.max(260,gallery.clientWidth*.8),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})}prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));gallery.addEventListener('scroll',state,{passive:true});window.addEventListener('resize',state);state()}


 const photos=[...root.querySelectorAll('[data-guru-photo]')],photoDialog=root.querySelector('[data-guru-photo-dialog]');
 if(photos.length&&photoDialog){let photoIndex=0;const image=photoDialog.querySelector('[data-guru-photo-full]'),caption=photoDialog.querySelector('[data-guru-photo-caption]');function showPhoto(index){photoIndex=(index+photos.length)%photos.length;const photo=photos[photoIndex];image.src=photo.dataset.src;image.alt=photo.dataset.alt;caption.textContent=photo.dataset.caption}photos.forEach((photo,index)=>photo.addEventListener('click',()=>{showPhoto(index);photoDialog.showModal()}));photoDialog.querySelector('[data-guru-photo-close]').addEventListener('click',()=>photoDialog.close());photoDialog.querySelector('[data-guru-photo-prev]').addEventListener('click',()=>showPhoto(photoIndex-1));photoDialog.querySelector('[data-guru-photo-next]').addEventListener('click',()=>showPhoto(photoIndex+1));photoDialog.addEventListener('click',event=>{if(event.target===photoDialog)photoDialog.close()});photoDialog.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'){event.preventDefault();showPhoto(photoIndex-1)}else if(event.key==='ArrowRight'){event.preventDefault();showPhoto(photoIndex+1)}})}
 const radios=[...root.querySelectorAll('[data-guru-variant]')],title=root.querySelector('[data-guru-selected-title]'),submit=root.querySelector('[data-guru-submit]');
 function updateVariant(input){if(title)title.textContent=input.dataset.title;if(submit){const canBuy=input.dataset.available==='true'&&root.dataset.pricePending!=='true';submit.disabled=!canBuy;submit.textContent=canBuy?submit.dataset.label:submit.dataset.unavailable}const url=new URL(window.location.href);url.searchParams.set('variant',input.value);history.replaceState({},'',url.toString())}
 radios.forEach(input=>input.addEventListener('change',()=>updateVariant(input)));
 const selected=radios.find(r=>r.checked);if(selected&&title)title.textContent=selected.dataset.title;
}
document.querySelectorAll('[data-guru-page]').forEach(initGuruPage);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-guru-page]').forEach(initGuruPage));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gate-raptor-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gate-raptor'))customElements.define('gate-raptor',class extends HTMLElement{
 connectedCallback(){
  if(this.dataset.ready){if(!this._motion)this._motion=setupHUSARMotion(this);if(!this._presentation)this._presentation=setupHUSARPresentation(this);return;}
  this.dataset.ready='true';
  this.querySelectorAll('[data-rp-product-gallery]').forEach(gallery=>{
   const track=gallery.querySelector('[data-rp-track]'),slides=[...gallery.querySelectorAll('[data-rp-slide]')],thumbs=[...gallery.querySelectorAll('[data-rp-thumb]')],counter=gallery.querySelector('[data-rp-photo-counter]'),previous=gallery.querySelector('[data-rp-photo-prev]'),next=gallery.querySelector('[data-rp-photo-next]');
   const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
   let active=0,frame=0,start;
   const sync=index=>{active=Math.max(0,Math.min(slides.length-1,index));slides.forEach((slide,i)=>{slide.setAttribute('aria-hidden',String(i!==active));slide.querySelector('button').tabIndex=i===active?0:-1});thumbs.forEach((thumb,i)=>{thumb.setAttribute('aria-pressed',String(i===active));thumb.tabIndex=i===active?0:-1});counter.textContent=`${active+1} / ${slides.length}`;previous.disabled=active===0;next.disabled=active===slides.length-1;const strip=gallery.querySelector('[data-rp-thumbs]'),thumb=thumbs[active];if(thumb.offsetLeft<strip.scrollLeft||thumb.offsetLeft+thumb.offsetWidth>strip.scrollLeft+strip.clientWidth)strip.scrollTo({left:thumb.offsetLeft-strip.offsetLeft,behavior:reduced?'auto':'smooth'})};
   const go=index=>{const selected=Math.max(0,Math.min(slides.length-1,index));track.scrollTo({left:slides[selected].offsetLeft-slides[0].offsetLeft,behavior:'auto'});sync(selected)};
   thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>go(i)));
   previous.addEventListener('click',()=>go(active-1));next.addEventListener('click',()=>go(active+1));
   gallery.addEventListener('keydown',event=>{let selected;if(event.key==='ArrowRight')selected=active+1;if(event.key==='ArrowLeft')selected=active-1;if(event.key==='Home')selected=0;if(event.key==='End')selected=slides.length-1;if(selected!==undefined){event.preventDefault();go(selected);if(event.target.closest('[data-rp-thumb]'))thumbs[active].focus()}});
   track.addEventListener('scroll',()=>{if(frame)return;frame=requestAnimationFrame(()=>{frame=0;sync(Math.round(track.scrollLeft/track.clientWidth))})},{passive:true});
   track.addEventListener('pointerdown',event=>{start={x:event.clientX,y:event.clientY}});
   track.addEventListener('pointerup',event=>{if(start&&Math.hypot(event.clientX-start.x,event.clientY-start.y)>12){gallery.dataset.swiping='true';setTimeout(()=>delete gallery.dataset.swiping,350)}start=null});
   sync(0);
  });
  this._motion=setupHUSARMotion(this);
  this._presentation=setupHUSARPresentation(this);
  const tabs=[...this.querySelectorAll('[data-rp-tab]')],panels=[...this.querySelectorAll('[data-rp-panel]')];
  const choose=tab=>{tabs.forEach(t=>{const selected=t===tab;t.setAttribute('aria-selected',String(selected));t.tabIndex=selected?0:-1});panels.forEach(panel=>{panel.hidden=panel.id!==tab.getAttribute('aria-controls');if(panel.hidden)panel.querySelectorAll('video').forEach(v=>v.pause())})};
  tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>choose(tab));tab.addEventListener('keydown',event=>{let target;if(event.key==='ArrowRight')target=tabs[(i+1)%tabs.length];if(event.key==='ArrowLeft')target=tabs[(i+tabs.length-1)%tabs.length];if(event.key==='Home')target=tabs[0];if(event.key==='End')target=tabs[tabs.length-1];if(target){event.preventDefault();choose(target);target.focus()}})});
  const dialog=this.querySelector('dialog'),image=dialog?.querySelector('img'),caption=dialog?.querySelector('[data-rp-caption]');
  this.querySelectorAll('[data-rp-image]').forEach(button=>button.addEventListener('click',()=>{if(button.closest('[data-rp-product-gallery]')?.dataset.swiping==='true')return;image.src=button.dataset.rpImage;image.alt=button.dataset.rpCaption;caption.textContent=button.dataset.rpCaption;this.querySelectorAll('video').forEach(v=>v.pause());dialog.showModal()}));
  dialog?.querySelector('[data-rp-close]')?.addEventListener('click',()=>dialog.close());
  dialog?.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();event.stopPropagation();dialog.close()}});
  dialog?.addEventListener('cancel',event=>{event.preventDefault();dialog.close()});
  dialog?.addEventListener('click',event=>{if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close()}});
 }
 disconnectedCallback(){this._motion?.destroy();this._motion=null;this._presentation?.destroy();this._presentation=null;}
});

function setupHUSARMotion(root){
 const abort=new AbortController(),signal=abort.signal;
 const loops=[...root.querySelectorAll('[data-rp-loop]')];
 const states=new Map(loops.map(video=>[video,{ratio:0,blocked:false,pending:false}]));
 const preference=matchMedia('(prefers-reduced-motion: reduce)'),connection=navigator.connection;
 let wanted=null,observer,manualObserver,destroyed=false;
 const on=(target,name,fn)=>target?.addEventListener(name,fn,{signal});
 const automatic=()=>root.dataset.autoplay==='true'&&!preference.matches&&!connection?.saveData;
 const overlayOpen=()=>root.querySelector('.rp-dialog[open]');
 const manualPlaying=()=>[...root.querySelectorAll('video:not([data-rp-loop])')].some(video=>!video.paused&&!video.ended);
 const attach=video=>{
  const source=video.querySelector('source');
  if(source.dataset.src&&!source.hasAttribute('src')){source.src=matchMedia('(max-width: 760px)').matches&&source.dataset.mobileSrc?source.dataset.mobileSrc:source.dataset.src;video.load();}
 };
 const schedule=()=>{
  let chosen=null;
  if(!destroyed&&!document.hidden&&root.isConnected&&automatic()&&!overlayOpen()&&!manualPlaying()){
   chosen=loops.filter(video=>{
    const s=states.get(video);
    return s.ratio>=.45&&!s.blocked;
   }).sort((a,b)=>states.get(b).ratio-states.get(a).ratio)[0]||null;
  }
  wanted=chosen;
  loops.forEach(video=>{if(video!==chosen)video.pause();});
  if(!chosen||!chosen.paused)return;
  const state=states.get(chosen);
  if(state.pending)return;
  state.pending=true;chosen.muted=true;attach(chosen);
  const attempt=chosen.play();
  Promise.resolve(attempt).then(()=>{
   state.pending=false;
   if(destroyed||wanted!==chosen||document.hidden||!automatic()||state.ratio<.45||overlayOpen())chosen.pause();
  }).catch(error=>{
   state.pending=false;
   if(error.name!=='AbortError')state.blocked=true;
   else if(!destroyed)queueMicrotask(schedule);
  });
 };
 loops.forEach(video=>{
  const s=states.get(video);
  on(video,'play',()=>{
   if(destroyed||wanted!==video||document.hidden||!automatic()||s.ratio<.45||overlayOpen()){video.pause();return;}
   root.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();});
  });
  on(video,'error',()=>{s.blocked=true;});
 });
 if('IntersectionObserver' in window){
  observer=new IntersectionObserver(entries=>{
   entries.forEach(entry=>states.get(entry.target).ratio=entry.intersectionRatio);
   schedule();
  },{threshold:[0,.2,.45,.6,.8,1]});
  loops.forEach(video=>observer.observe(video));
  manualObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.intersectionRatio===0)entry.target.pause();}),{threshold:0});
  root.querySelectorAll('.rp-film video:not([data-rp-loop])').forEach(video=>manualObserver.observe(video));
 }
 root.querySelectorAll('video:not([data-rp-loop])').forEach(video=>{
  on(video,'play',()=>{
   wanted=null;
   root.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();});
  });
  on(video,'pause',()=>queueMicrotask(schedule));
  on(video,'ended',()=>queueMicrotask(schedule));
 });
 on(root.querySelector('.rp-dialog'),'close',schedule);
 on(root.querySelector('.rp-dialog'),'toggle',schedule);
 on(document,'visibilitychange',()=>{if(document.hidden)root.querySelectorAll('video').forEach(video=>video.pause());schedule();});
 on(preference,'change',schedule);on(connection,'change',schedule);
 return {destroy(){destroyed=true;wanted=null;observer?.disconnect();manualObserver?.disconnect();abort.abort();root.querySelectorAll('video').forEach(video=>video.pause());}};
}

function setupHUSARPresentation(root){
 const abort=new AbortController(),preference=matchMedia('(prefers-reduced-motion: reduce)');
 const selector='.rp-overview-head>* ,.rp-freefloat-heading>* ,.rp-prose,.rp-heading,.rp-motion,.rp-axis-cards article,.rp-benefits article,.rp-hopup-figure,.rp-engineering-copy,.rp-etu-grid>*,.rp-gcs-grid>*,.rp-autocal-grid>*,.rp-gallery>figure,.rp-autocal-steps>li,.rp-fit,.rp-qc-figure,.rp-qc-steps>li,.rp-heritage-figure,.rp-efficiency-note';
 const targets=[...root.querySelectorAll(selector)].filter(node=>!node.parentElement.closest(selector));
 let observer;
 const show=node=>{node.dataset.rpReveal='shown';observer?.unobserve(node);};
 const showAll=()=>{targets.forEach(show);observer?.disconnect();};
 const enabled=()=>!preference.matches&&!navigator.connection?.saveData&&'IntersectionObserver' in window;
 root.dataset.rpPresentation='ready';
 if(enabled()){
  observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting)show(entry.target);}),{threshold:0,rootMargin:'0px 0px -3% 0px'});
  targets.forEach(node=>{
   const parent=node.parentElement;
   if(parent.matches('.rp-benefits,.rp-axis-cards,.rp-autocal-steps,.rp-qc-steps'))node.style.setProperty('--rp-reveal-delay',`${Math.min([...parent.children].indexOf(node)*65,130)}ms`);
   if(node.getBoundingClientRect().top<innerHeight-24)show(node);
   else{node.dataset.rpReveal='pending';observer.observe(node);}
  });
 }
 const onPreference=()=>{if(!enabled())showAll();};
 preference.addEventListener('change',onPreference,{signal:abort.signal});
 navigator.connection?.addEventListener('change',onPreference,{signal:abort.signal});
 root.addEventListener('focusin',event=>targets.filter(node=>node.contains(event.target)).forEach(show),{signal:abort.signal});
 return {destroy(){showAll();abort.abort();delete root.dataset.rpPresentation;targets.forEach(node=>{delete node.dataset.rpReveal;node.style.removeProperty('--rp-reveal-delay');});}};
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["husar-launch-utility"] && !Shopify.designMode) return;
  try {
    
function husarCountryInit(){document.querySelectorAll('[data-hl-country]:not([data-ready])').forEach(select=>{select.dataset.ready='true';select.addEventListener('change',()=>select.form.submit())})}
husarCountryInit();document.addEventListener('shopify:section:load',husarCountryInit);

  } catch(e) { console.error(e); }
})();
})();
